import { render } from "./DeliveryAddAddress.vue?vue&type=template&id=1af06253"
import script from "./DeliveryAddAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddAddress.vue?vue&type=script&lang=js"
script.render = render

export default script